import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
// import VConsole from 'vconsole';
import App from './App.jsx';
import { checkIsOneScreen } from './service/util.js';

if (process.env.NODE_ENV === 'development') {
  // new VConsole();
}

addLocaleData([...en]); // 依赖的环境，用于实现复数和相对时间格式化功能 https://github.com/yahoo/react-intl/wiki#loading-locale-data

// 配置项
const LOCALE = 'en-US'; // 当前语言环境
const LANGUAGES = ['en-US']; // 所有语言环境

const messages = {};

LANGUAGES.forEach(locale => {
  messages[locale] = require(`./locales/${locale}`).default;
});

  const isOneScreen = checkIsOneScreen()
  document.title = isOneScreen ? 'OneScreen Class' : 'Airclass'
  document.body.style.setProperty('--theme-primary', isOneScreen ? '#7dc242' : '#00bfa1')
  document.body.style.setProperty('--theme-btn-pressed', isOneScreen ? '#8aab6d' : '#00917a')
  document.body.style.setProperty('--theme-btn-disabled', isOneScreen ? '#cbe6b3' : '#b2ebe2')

const designWidth = 375; // 视觉宽度
const rem2px = 16;

// 响应式字体大小
function resetHtmlFontSize() {
  if (document.body.clientWidth < 570) {
    document.documentElement.style.fontSize =
      (document.body.clientWidth / designWidth) * rem2px + 'px';
  } else {
    document.documentElement.style.fontSize = '24px';
  }
}
(window.onresize = resetHtmlFontSize)();

ReactDOM.render(
  <IntlProvider locale={LOCALE} messages={messages[LOCALE]}>
    <App />
  </IntlProvider>,
  document.getElementById('root')
);
